module.exports = {"testnet":{"GBYTE":"base","USDC":"UccpQo12uLmufihkzdK7Kcrb5BlHp8GcMrSEA7NVdNw="},"livenet":{"GBYTE":"base","USDC":"S/oCESzEO8G2hvQuI6HsyPr0foLfKwzs+GU73nO9H40="}}


//////////////////
// WEBPACK FOOTER
// ./src/config/assets.json
// module id = 501
// module chunks = 0